import { computed, defineComponent, h } from "@vue/composition-api";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { $t } from "@/lib/i18nHelpers";
import getIntegration from "@/payments/integrations";
import { IntegrationModule } from "@/payments/integrations/types";
import config from "@/config";
import { PurchaseType } from "@/const";

const BALANCE_SYSTEM_TYPE = $t("balance");

export const isBalanceSystem = (type: string) => type === BALANCE_SYSTEM_TYPE;

export const myBalanceFakeSystem: PaymentSystemPublic = {
  id: "0",
  type: BALANCE_SYSTEM_TYPE,
  currencies: [],
};

export const myBalanceFakeSystemIntegration = computed<IntegrationModule<any>>(() => ({
  paymentComponent: defineComponent({
    render() {
      return h();
    },
  }),
  purchase: config.featurePurchaseFromBalance
    ? () => Promise.resolve({ status: false, subjectPurchased: false })
    : undefined,
  subscribe: config.featureSubscribeFromBalance
    ? () => Promise.resolve({ status: false, subjectPurchased: false })
    : undefined,
  allowSaveCard: false,
  name: $t("My balance"),
  logo: "",
}));

export const getPaymentMethodBySystem = (system: PaymentSystemPublic) => {
  return isBalanceSystem(system.type) ? myBalanceFakeSystemIntegration.value : getIntegration(system);
};

export const getAvailableSystems = (systems: PaymentSystemPublic[], purchaseType: PurchaseType) => {
  const unsupportedPaymentSystemsTypes: string[] = [];
  return systems
    .map(system => {
      const integration = getPaymentMethodBySystem(system);
      if (
        !integration.name ||
        (purchaseType === PurchaseType.SUBSCRIPTION && !integration.subscribe) ||
        (purchaseType === PurchaseType.ONE_TIME && !integration.purchase) ||
        (purchaseType === PurchaseType.TOP_UP && isBalanceSystem(system.type)) ||
        (purchaseType === PurchaseType.ONE_TIME_BALANCE && !isBalanceSystem(system.type))
      ) {
        unsupportedPaymentSystemsTypes.push(system.type);
      }
      return { system, integration };
    })
    .filter(s => !unsupportedPaymentSystemsTypes.includes(s.system.type));
};

const cryptoSystems = ["payid19", "zyrox"];
// what the buyer can pay with, under the name of each payment system (CO-15584). onlyfats CCBill (CO-15589): its payment
// page offers Visa, Discover, JCB, Diners Club; Mastercard is not approved for new URLs of her account (CCBill
// Compliance), Amex is off. NETbilling cards, Zyrox crypto
const acceptedPayments: Record<string, string> = {
  "ccbill-flexform": "Visa, Discover, JCB, Diners Club",
  "netbilling": "Visa, Mastercard",
  "zyrox": "Crypto",
};

export const getAcceptedPayments = (type: string) =>
  $t(acceptedPayments[type] ?? (cryptoSystems.includes(type) ? "Crypto payment" : "Credit card"));
